var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"custom-main custom-main-document"},[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"1"}}),_c('v-col',{attrs:{"cols":"12","lg":"10"}},[_c('router-view')],1),_c('v-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"1"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }